// Source: https://stackoverflow.com/a/17323608/1540547
export const positiveModulo = (dividend: number, divisor: number): number => ((dividend % divisor) + divisor) % divisor;
